<button mat-raised-button color="primary" (click)="createannouncement()">
  Create Announcement
</button>
<div class="container mt-4">
  <div class="row">
    <div class="col-md-6 mb-4"*ngFor="let announcement of announcementArr">
      <div class="card">
        <div class="card-header" [style.backgroundColor]="announcement.windowColor || '#0d6efd'" [style.color]="announcement.textColor || '#ffffff'">
           {{ announcement.announcement }}
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="mb-1"><strong>Type:</strong> {{ announcement.type }}</p>
                <p class="mb-1"><strong>Time:</strong> {{ announcement.startTime }} - {{ announcement.endTime }}</p>
                <p class="mb-1"><strong>Priority:</strong> {{ announcement.priority }} &nbsp;|&nbsp; <strong>Active:</strong> {{ announcement.active }}</p>
                <p class="mb-1"><strong>Background:</strong> {{ announcement.windowColor || '#0d6efd' }}</p>
                <p class="mb-0"><strong>Text:</strong> {{ announcement.textColor || '#ffffff' }}</p>
              </div>
              <div>
                <button class="btn btn-sm btn-outline-primary" (click)="editAnnouncement(announcement)">Edit</button>
                <button class="btn btn-sm btn-outline-danger" (click)="deleteAnnouncement(announcement)">Delete</button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
